export default class MenuManager {
    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        let menuNavigationOptions = $('[data-entity="menu-navigation-options"]');
        let menuUserPanelOptions = $('[data-entity="menu-user-panel-options"]');
        let closeMobileMenu = $('[data-entity="close-mobile-menu"]');
        let closeMobileMenuUserPanel = $('[data-entity="close-mobile-menu-user-panel"]');

        $('[data-entity="open-mobile-menu"]').on('click', (e) => {
            menuNavigationOptions.addClass('show-menu');
            $('body').addClass('modal-open');
            myApp.browserHistoryManager.addState('[data-entity="close-mobile-menu"]');
        });

        closeMobileMenu.on('click', (e) => {
            myApp.browserHistoryManager.removeState('[data-entity="close-mobile-menu"]');
        });

        closeMobileMenu.on('pop-state', (e) => {
            menuNavigationOptions.removeClass('show-menu');
            $('body').removeClass('modal-open');
        });

        closeMobileMenuUserPanel.on('click', (e) => {
            myApp.browserHistoryManager.removeState('[data-entity="close-mobile-menu-user-panel"]');
        });

        closeMobileMenuUserPanel.on('pop-state', (e) => {
            menuUserPanelOptions.removeClass('show-menu');
            $('body').removeClass('modal-open');
        });

        $('[data-action="menu-option-collapse"]').on('click', (e) => {
            let extraMenuNavigation = $(e.currentTarget).closest('[data-entity="extra-menu-navigation-options"]');
            if (extraMenuNavigation.length > 0 && (myApp.deviceDetector.isLgScreen())) {
                return;
            }

            e.preventDefault();

            let menuOption = $(e.currentTarget).closest('.menu-option');
            let activeItems = $('.menu-option.active-menu').not(menuOption);
            activeItems.find('.menu-options-container').slideUp('fast');
            activeItems.removeClass('active-menu');

            menuOption.find('.menu-options-container').slideToggle('fast');
            menuOption.toggleClass('active-menu');
            if (!myApp.deviceDetector.isSmScreen()) {
                this.adjustNavigationColumns(event);
            }
        });

        document.body.addEventListener('click', (event) => {
            const menuOption = event.target.closest('.menu-option');
            const extraMenuNavigation = event.target.closest('[data-container="extra-menu-navigation-options"]');
            if (!menuOption) {
                $('.menu-options-container').slideUp('fast');
                $('[data-entity="menu-navigation-options"] .menu-option').removeClass('active-menu');
            }

            if (!extraMenuNavigation) {
                $('[data-action="toggle-extra-menu-navigation"]').removeClass('open');
                $('[data-entity="extra-menu-navigation-options"]').slideUp('fast');
            }
        });

        $('[data-action="toggle-extra-menu-navigation"]').on('click', (e) => {
            $(event.currentTarget).toggleClass('open');
            $('[data-entity="extra-menu-navigation-options"]').slideToggle('fast');
        });

        $('[data-action="open-menu"]').on('click', (event) => {
            let collapseId = $(event.currentTarget).data('id');
            myApp.browserHistoryManager.addState('[data-collapse-id="' + collapseId + '"]');
        });

        $('[data-action="close-menu"]').on('click', (event) => {
            let collapseId = $(event.currentTarget).data('id');
            myApp.browserHistoryManager.removeState('[data-collapse-id="' + collapseId + '"]');
        });

        $('[data-collapse="menu-collapse"]').on('pop-state', (event) => {
            $('#containerUserMenu, #filter').removeClass('show');
            $('body').removeClass('filters-opened');
            $('#menu_overlay').hide();
        });

        const userProfileImg = document.querySelectorAll('[data-entity="userProfileImage"]');
        userProfileImg.forEach((element) => {
            let userPhoto = element.getAttribute('data-user-photo');
            if (userPhoto) {
                element.src = element.getAttribute('data-user-photo');
            }

            if (!element.getAttribute('src')) {
                this.createUserInitials(element);
            }

            element.addEventListener('error', (e) => {
                const currentTarget = e.currentTarget;
                this.createUserInitials(currentTarget);
            });
        });
    }

    createUserInitials(currentTarget) {
        let userInitials = currentTarget.getAttribute('data-user-initials');
        let newProfileImg = document.createElement('div');
        newProfileImg.innerHTML = userInitials ? userInitials : 'U';
        newProfileImg.classList = currentTarget.classList;
        if (!document.querySelector('.vip-user-image')) {
            newProfileImg.classList.add(
                'profile-picture',
                currentTarget.getAttribute('data-error-class') ?? 'default'
            );
        }
        currentTarget.parentNode.insertBefore(newProfileImg, currentTarget.parentNode.firstChild);
        currentTarget.remove();
    }

    adjustNavigationColumns(event) {
        const navigationCategory = $($(event.currentTarget).closest('.menu-option')).find('.menu-options-container')[0];
        if (navigationCategory) {
            const menuContainer = document.querySelector('.menu-container.desktop-header');
            if (!menuContainer) {
                return;
            }

            const navigationTranslation = (navigationCategory.getBoundingClientRect().right - menuContainer.getBoundingClientRect().right);
            if (navigationTranslation > 0) {
                navigationCategory.style.transform = `translateX(-${navigationTranslation+25}px)`;
            }
        }
    }
}
